import { render, staticRenderFns } from "./diamondList.vue?vue&type=template&id=4c657d48&"
import script from "./diamondList.vue?vue&type=script&lang=js&"
export * from "./diamondList.vue?vue&type=script&lang=js&"
import style0 from "./diamondList.vue?vue&type=style&index=0&id=4c657d48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports